import React from "react";
import CheckCircle from "../../../assets/svgs/CheckCircle";
import RemoveCircle from "../../../assets/svgs/RemoveCircle";

function Tr({
  country,
  cycle,
  process,
  status,
  employess,
  grosspay,
  expenses,
  bonus,
  total,
  approve,
}) {
  return (
    <tr className="border-b">
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {country}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {cycle}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {process}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {status}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {employess}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {grosspay}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {expenses}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {bonus}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        {total}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm font-medium text-gray-900 border-r">
        <div className="flex justify-around">
          <button className="text-red-500">
            <RemoveCircle />
          </button>
          <button className="text-green-500">
            <CheckCircle />
          </button>
        </div>
      </td>
    </tr>
  );
}

const Table = () => {
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <div className="py-2 inline-block min-w-full">
          <div className="overflow-hidden">
            <table className="min-w-full border text-center">
              <thead className="border-b">
                <tr>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Country
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Cycle
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Process
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Status
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Employees
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Gross pay
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Expenses
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Bonus
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5 border-r">
                    Total
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-5">
                    Approve
                  </th>
                </tr>
              </thead>
              <tbody>
                <Tr
                  country="United States"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Canada"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Japan"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="United States"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Canada"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Japan"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="United States"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Canada"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
                <Tr
                  country="Japan"
                  cycle="15 - 13 Appril"
                  process="0/4"
                  status="Nothing Yet"
                  employess="1"
                  grosspay="€3,500,00"
                  expenses="€400"
                  bonus="€300"
                  total="€4,200,00"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
